// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qBKr","content":"styles_content__239ED","row":"styles_row__zmMe6","footer":"styles_footer__1k_v5","phraseLength":"styles_phraseLength__355KJ"};